import { z } from 'zod';

import { UserProfile } from '@digital-platform/rs-classic/domain';

// Corresponds to data returned by the Auth0 id_token

// TODO: Change z.any() to a real zod schema
export const UserSchema = z.object({
  site: z.any().optional(),
  sites: z.any().optional(),
  loaded: z.boolean().optional(),
  state: z.enum(['AS1', 'AS2', 'AS3', 'AS4']).optional(),
  profile: UserProfile.optional(),
  shouldMaskAccountId: z.boolean().optional(),
  isAuthenticated: z.boolean().optional(),
  invalidState: z.any().optional(),
  fullName: z.string().optional(),
  account: z.any().optional(),
  details: z.any().optional(),
  serviceLocation: z.any().optional(),
  displayName: z.string().optional(),
});

export type User = z.infer<typeof UserSchema>;

export const AnonymousUser: User = UserSchema.parse({
  site: undefined,
  sites: undefined,
  loaded: undefined,
  state: undefined,
  profile: undefined,
  shouldMaskAccountId: undefined,
  isAuthenticated: undefined,
  invalidState: undefined,
  fullName: undefined,
  account: undefined,
  details: undefined,
  serviceLocation: undefined,
  displayName: undefined,
});

export const UserFromClassic = UserSchema.transform((val) => {
  const user = val;

  return user;
}).pipe(UserSchema);
